<template>

  <div class="recommend-item">
    <div class="recommend-item__photo-wrap">
        <div class="swiper-container appart-photo-container js-appartPhotoSlider">

                <swiper ref="swiperItem" class="swiper appart-photo-swiper-container" :options="swiperSmallOption">
                  <swiper-slide class="swiper-slide appart-photo-slide"
                    v-for="photo in slider" :key="photo"
                  >
                    <div class="appart-photo" :style="{ backgroundImage: `url(${photo})` }"></div>
                  </swiper-slide>
                </swiper>


            <div class="appart-photo-btn appart-photo-btn-prev js-appartPhotoSliderBtnPrev" slot="button-prev" @click="swiperItem.slidePrev()">
                <img src="/images/recommend/recommend-sm-prev.svg" alt="">
            </div>
            <div class="appart-photo-btn appart-photo-btn-next js-appartPhotoSliderBtnNext" slot="button-prev" @click="swiperItem.slideNext()">
                <img src="/images/recommend/recommend-sm-next.svg" alt="">
            </div>
            <div class="appart-photo-pagination js-appartPhotoSliderPagination" slot="pagination"></div>
        </div>
    </div>

    <div class="recommend-item__info">
        <div class="recommend-item__title">{{name}}</div>
        <div class="recommend-item__label-row">
            <div class="recommend-item__label"
              v-for="typeItem in tags[code]"
              :key="typeItem"
            >{{typeItem}}</div>
        </div>
        <div class="recommend-item__btn-row">
            <a class="btn btn_green recommend-item__btn" :href="`http://${url}`" target="_blank">Посмотреть {{ type }}</a>
        </div>
    </div>
  </div>
</template>
<script>
    // import Popup from "../components/Popup";
    // import Loading from 'vue-loading-overlay';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
      name: 'recommend-item',
      components: {Swiper, SwiperSlide},
      data() {
            return {
              // isLoading: false,
              // fullPage: true,
              swiperSmallOption: {
                slidesPerView: 1,
                spaceBetween: 0,
                // navigation: {
                //   nextEl: '.js-recommendSliderBtnNext',
                //   prevEl: '.js-recommendSliderBtnPrev',
                // },
                observer: true,
                observeSlideChildren: true,
                observeParents: true,
                allowTouchMove: false,
                pagination: {
                  el: '.js-appartPhotoSliderPagination'
                }
              },
              tags: {
                  oko: ['В том же бюджете', 'С отделкой'],
                  tricolor: ['В том же бюджете'],
                  litsa: ['В том же бюджете'],
                  "head-liner": ['В том же бюджете', 'Больше площадь'],
              }
            }
        },
        computed: {
          swiperItem() {
            return this.$refs.swiperItem.$swiper
          }
        },
        async mounted() {

        },
        methods: {
        },
        props: {
            slider: Array,
            name: String,
            code: String,
            url: String,
            type: String
        }

    }
</script>
<style lang="scss">
  @import '../../../sass/variables';



.recommend-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
     -moz-box-orient: vertical;
     -moz-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  width: 100%;
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;

    @media (max-width: $mobile-max-width) {
      padding-right: 2rem;
    }

  &__photo-wrap {
      width: 100%;
      position: relative;
  }
  &__photo {
      display: block;
      position: relative;
      width: 100%;
      padding-bottom: 76%;
      height: auto;
      background-position: center;
      background-repeat: no-repeat;
      -webkit-background-size: cover;
          -moz-background-size: cover;
            -o-background-size: cover;
              background-size: cover;
  }
  &__info {
      padding-top: 1.3rem;
      padding-bottom: 3.6rem;
      -webkit-flex-basis: 0;
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
          -moz-box-orient: vertical;
          -moz-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;

      @media (max-width: $mobile-max-width) {
        padding-bottom: 5rem;
      }
  }
  &__title {
      font-style: normal;
      font-size: 2.1rem;
      letter-spacing: 0.06em;
      line-height: 1.5;
      font-weight: 700;
      color: #000000;
      margin-bottom: 0;

  }
  &__label-row {
      font-style: normal;
      margin-top: 1.5rem;

          font-weight: 600;
          font-size: 1.2rem;
          line-height: 1.5;
          color: #000000;
          letter-spacing: 0.01rem;

         @media (max-width: $mobile-max-width) {
              margin-top: 1.4rem;
              font-size: 1.4rem;
          }
  }
  &__label {
      display: inline-block;
      background: #F1F2F4;
      -webkit-border-radius: 0.16rem;
      -moz-border-radius: 0.16rem;
      border-radius: 0.16rem;
      padding: 0.4rem 0.65rem 0.3rem 0.65rem;
      margin-right: 0.6rem;
      margin-bottom: 0.6rem;
      background-color: #EEEFEF;
      border-radius: 0.24rem;


      @media (max-width: $mobile-max-width) {
        padding: 0.5rem 0.85rem 0.3rem 0.85rem;
        margin-right: 0.6rem;
        margin-bottom: 0.5rem;
      }
  }
  &__btn {
      display: inline-block;
      text-align: center;
      color: #885635;
      border: 1px solid #885635;
      background-color: transparent;
      display: inline-block;
      padding: 1.2rem 2.1rem 1.0rem 2.1rem;
      border-radius: 0;
      font-style: normal;
      font-weight: 600;
      font-size: 1.05rem;
      text-transform: uppercase;
      line-height: 1.2;

      &:hover {
        background-color: #885635;
        color: #ffffff;
      }
    @media (max-width: $mobile-max-width) {
      font-size: 1.4rem;
      padding: 1.4rem 2.1rem 1.3rem 2.1rem;
    }
  }
  &__btn-row {
      padding-top: 1.8rem;
      margin-top: auto;

      @media (max-width: $mobile-max-width) {
        padding-top:2.4rem;
      }
  }
}




.swiper-slide.recommend__slide {
  display: flex;
  height: auto;
}

.appart-photo {
  display: block;
  position: relative;
  width: 100%;
  padding-bottom: 76%;
  height: auto;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
     -moz-background-size: cover;
       -o-background-size: cover;
          background-size: cover;
}


.appart-photo-btn {
  display: block;
  position: relative;
  width: 2.6rem;
  height: 2.6rem;
  -webkit-border-radius: 2.6rem;
     -moz-border-radius: 2.6rem;
          border-radius: 2.6rem;
  left: 0.8rem;
  position: absolute;
  top: 50%;
  margin-top: -1.3rem;
  z-index: 1;
  cursor: pointer;
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);

  img {
      display: block;
      width: 100%;
      height: 100%;
      -o-object-fit: contain;
          object-fit: contain;
      -o-object-position: center;
          object-position: center;
  }
  &.swiper-button-disabled {
      cursor: default;
      opacity: 0.6;
  }
  &.appart-photo-btn-next {
      left: auto;
      right: 0.8rem;
  }
}

.appart-photo-pagination {
  position: absolute;
  bottom: 1rem;
  left: 0;
  width: 100%;
  height: auto;
  top: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
     -moz-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
     -moz-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
  z-index: 1;
}
.swiper-container-horizontal>.swiper-pagination-bullets.appart-photo-pagination {
  bottom: 16px;
}
.appart-photo-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: #ffffff;
  -webkit-transition: background-color 0.2s 0s;
  -o-transition: background-color 0.2s 0s;
  -moz-transition: background-color 0.2s 0s;
  transition: background-color 0.2s 0s;
  margin: 0 5px;
}
.appart-photo-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  background-color: #326664;
}

</style>
